import _ from 'lodash';

import { combineReducers } from 'redux';

import findCacheState from 'utils/find-cache-state';
import c from 'common/constants/flux-events';

import {
    validateAdDraft,
    applyBillingTermChange,
    applyBillingEnabledChange,
    applyMaxTotalSpendFix,
    applyBillingRateFix,
} from 'forms/ad-form/services';

import poiViewer from './reducer-poi-viewer';

const initialState = {
    draft: null,
    isDraftValid: false,
    errors: [],
    showErrors: false,
    isAdPresetModalOpen: false,
    isLoading: true,
    isSubmiting: false,
    isDirty: false,
    unassignedPoints: [], // @TODO to remove
    poiViewer: null,
    searchString: '',
    // geoLayerFinder_folderState: {},
    geoCategories: null,
};

import { getDefaults } from 'services/resources/ad-preset';

export const NAME = 'adEditForm';

export default combineReducers({
    form,
    poiViewer,
});

function form(state = {}, action) {
    switch (action.type) {
        // case c.OVERVIEW_ADS__AD_DRAFT_EDIT__INIT_STATE: {
        //     const { campaignId} = action.payload;

        //     return findCacheState(campaignId, state, initialState);
        // }

        // case c.OVERVIEW_ADS__AD_DRAFT_EDIT__OPEN: {
        //     return {
        //         ...state,
        //         isLoading: true
        //     };
        // }

        // case c.OVERVIEW_ADS__AD_DRAFT_EDIT__INIT_GEO_POINTS: { //@TODO this is Alex's code, removed when refactoring
        //     // add a temp pointId for tracking adding and deleting points from session
        //     const unassignedPoints = _.map(action.payload.points, point => {
        //         return {
        //             ...point,
        //             pointId: _.uniqueId(),
        //         };
        //     });

        //     return {
        //         ...state,
        //         unassignedPoints,
        //     };
        // }

        // case c.OVERVIEW_ADS__AD_DRAFT_EDIT__INIT: {
        //     const { campaign } = action.payload;
        //     const sessionDraft_current = _.get(state, `draft`, null);
        //     let sessionDraft_next = sessionDraft_current;

        //     if ( sessionDraft_current === null ) {
        //         // Only inititialize session's draft if there isn't already one.
        //         // This is to prevent router reruning when user navigates to edit creative form.
        //         sessionDraft_next = _.get(action, 'payload.ad');
        //     }

        //     const errors = validateAdDraft(sessionDraft_next, campaign.billing_enabled);

        //     // poi module
        //     const geoCategories_current = _.get(state, 'geoResources', null);
        //     let geoCategories_next = geoCategories_current;
        //     if ( geoCategories_current === null ) {
        //         // Only inititialize session's draft if there isn't already one.
        //         // This is to prevent router reruning when user navigates to edit creative form.
        //         geoCategories_next = _.get(action, 'payload.geoCategories');
        //     }

        //     const o = {
        //         ...state,
        //         errors,
        //         isDraftValid: errors.length === 0,
        //         draft: sessionDraft_next,
        //         isLoading: false,
        //         isDirty: false,
        //         geoCategories: geoCategories_next
        //     };
        //     return o;
        // }

        // case c.OVERVIEW_ADS__AD_DRAFT_EDIT__INIT_FAIL: {
        //     const httpErrors = _.map(action.error, error => ({
        //         field: error.field,
        //         message: error.message
        //     }));
        //     return {
        //         ...state,
        //         errors: httpErrors
        //     };
        // }

        // case c.OVERVIEW_ADS__AD_DRAFT_EDIT__UPDATE: {
        //     const { formData, campaignBillingEnabled } = action.payload;

        //     let nextDraft = {
        //         ...state.draft,
        //         ...formData
        //     };
        //     nextDraft = applyBillingTermChange(nextDraft, state, formData);
        //     nextDraft = applyBillingEnabledChange(nextDraft, state, formData);
        //     nextDraft = applyBillingRateFix(nextDraft, state, formData);
        //     nextDraft = applyMaxTotalSpendFix(nextDraft, state, formData);
        //     const errors = validateAdDraft(nextDraft, campaignBillingEnabled);

        //     return {
        //         ...state,
        //         draft: nextDraft,
        //         isDirty: true,
        //         errors,
        //         isDraftValid: errors.length === 0
        //     };
        // }

        // case c.OVERVIEW_ADS__AD_DRAFT_EDIT__SHOW_ERRORS: {
        //     return {
        //         ...state,
        //         showErrors: true,
        //     };
        // }

        case c.OVERVIEW_ADS__AD_DRAFT_EDIT__SUBMIT: {
            const { campaign } = action.payload;

            const errors = validateAdDraft(state.draft, campaign.billing_enabled);

            return {
                ...state,
                isSubmiting: true,
                errors,
            };
        }

        // case c.OVERVIEW_ADS__AD_DRAFT_EDIT_OPEN_AD_PRESET_MODAL: {
        //     return {
        //         ...state,
        //         isAdPresetModalOpen: true
        //     };
        // }

        // case c.OVERVIEW_ADS__AD_DRAFT_EDIT_CLOSE_AD_PRESET_MODAL: {
        //     return {
        //         ...state,
        //         isAdPresetModalOpen: false
        //     };
        // }

        // case c.OVERVIEW_ADS__AD_DRAFT_EDIT_SET_AD_PRESET: {
        //     const { adpreset } = action.payload;

        //     const enabledFields = _.reduce(adpreset.ad_preset_properties, (result, item) => {
        //         _.each(_.filter(item.properties, pr => pr.checked === true), prop => {
        //             result.push(prop.key);
        //         }, []);
        //         return result;
        //     }, []);

        //     return {
        //         ...state,
        //         draft: {
        //             ...state.draft,
        //             ..._.pick(
        //                 adpreset,
        //                 enabledFields
        //             )
        //         },
        //         isAdPresetModalOpen: false
        //     };
        // }

        case c.OVERVIEW_ADS__AD_DRAFT_EDIT__SUBMIT_FAIL: {
            const httpErrors = _.map(action.error, error => ({
                field: error.field,
                message: error.message,
            }));

            return {
                ...state,
                errors: httpErrors,
                showErrors: true,
                isLoading: false,
                isSubmiting: false,
                isDraftValid: false,
            };
        }

        case c.OVERVIEW_ADS__AD_DRAFT_EDIT__SUBMIT_SUCCESS: {
            return {
                ...state,
                isSubmiting: false,
            };
        }

        // case c.OVERVIEW_ADS__AD_DRAFT_EDIT__CLOSE: {
        //     return {
        //         ...initialState,
        //         unassignedPoints: [],
        //     };
        // }

        // case c.OVERVIEW_ADS__AD_DRAFT_EDIT__ADD_GEO_POINT: {
        //     const { unassignedPoints } = state;
        //     const { point } = action.payload;

        //     const newPoints = [
        //         ...unassignedPoints,
        //         point,
        //     ];

        //     return {
        //         ...state,
        //         unassignedPoints: newPoints
        //     };
        // }

        // case c.OVERVIEW_ADS__AD_DRAFT_EDIT__REMOVE_GEO_POINT: {
        //     const { unassignedPoints } = state;
        //     const { tempPointId } = action.payload;

        //     const newPoints = _.filter(unassignedPoints, point => point.pointId !== tempPointId);

        //     return {
        //         ...state,
        //         unassignedPoints: newPoints
        //     };
        // }

        // case c.SYSTEM__GEO_LAYERS__POST__SUCCESS: {
        //     return {
        //         ...state,
        //         unassignedPoints: [],
        //     };
        // }

        // case c.OVERVIEW_ADS__AD_DRAFT_EDIT__GEOLAYER_SEARCH_STRING_CHANGED: {
        //     const { searchString } = action.payload;
        //     const { geoCategories } = action.payload;

        //     return {
        //         ...state,
        //         searchString,
        //         geoCategories
        //     };
        // }

        // case c.OVERVIEW_ADS__AD_DRAFT_EDIT__GEOLAYER_FINDER__REFRESH: {
        //     const { geoCategories } = action.payload;

        //     return {
        //         ...state,
        //         geoCategories
        //     };
        // }

        // case c.OVERVIEW_ADS__AD_DRAFT_EDIT__GEOLAYER_FINDER__FOLDER_STATE_CHANGED: {
        //     const { geoCategories } = action.payload;

        //     return {
        //         ...state,
        //         geoCategories
        //     };
        // }

        default:
            return state;
    }
}
